import { BANNER_CONSTANTS, BANNER_VARIANTS } from '@/constants/banners'

export interface MobileBannerConfig {
  variant?: 'prelaunch' | 'services' | 'training' | 'default'
  title: string
  description: string
  buttonText?: string
  buttonAction?: () => void
  leftPillText?: string
  rightText?: string
}

export const useMobileBanner = () => {
  const { isDesktop } = useAppBreakpoints()
  const { isRouteMatch, hasQueryParam } = useRouteHelpers()
  const training = useTraining()

  const openTelegramChannel = () => {
    window.open(BANNER_CONSTANTS.TELEGRAM.URL, '_blank')
  }

  const shouldShowPrelaunchBanner = (): boolean => {
    if (isDesktop.value) return false
    return !hasQueryParam('explore', 'map')
  }

  const getBannerConfig = (): MobileBannerConfig | null => {
    if (isRouteMatch(['index', 'prelaunch']) && shouldShowPrelaunchBanner()) {
      return {
        variant: BANNER_VARIANTS.PRELAUNCH,
        title: BANNER_CONSTANTS.PRELAUNCH.TITLE,
        description: BANNER_CONSTANTS.PRELAUNCH.DESCRIPTION,
        buttonText: BANNER_CONSTANTS.TELEGRAM.TEXT,
        buttonAction: openTelegramChannel
      }
    }
    
    if (isRouteMatch(['services'])) {
      return {
        variant: BANNER_VARIANTS.SERVICES,
        title: BANNER_CONSTANTS.SERVICES.TITLE,
        description: BANNER_CONSTANTS.SERVICES.DESCRIPTION,
        buttonText: 'Learn More',
        buttonAction: () => navigateTo('/services'),
        leftPillText: BANNER_CONSTANTS.SERVICES.LEFT_PILL_DEFAULT,
        rightText: BANNER_CONSTANTS.SERVICES.RIGHT_TEXT_DEFAULT
      }
    }

    if (isRouteMatch(['training'])) {
      return {
        variant: BANNER_VARIANTS.TRAINING,
        title: `${training.watchedCount.value} Videos Watched`,
        description: '',
      }
    }
    
    return null
  }

  const getHeaderHeight = (): number => {
    const baseHeaderHeight = 88
    const bannerConfig = getBannerConfig()
    
    if (bannerConfig) {
      return baseHeaderHeight + 60
    }
    
    return baseHeaderHeight
  }

  return {
    getBannerConfig,
    getHeaderHeight
  }
}